<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-card-title>OT Schedule</v-card-title>
    <v-card-title>
      <!--
      <v-spacer></v-spacer>
      <v-spacer></v-spacer> -->
      <v-col cols="12" md="2">
        <template>
          <v-autocomplete
              :items="doctors"
              color="white"
              item-text="dr_name"
              item-key="id"
              item-value="id"
              label="Doctor List"
              v-model="searchParam.surgeon_id"
              :loading="loadingstatus"
              outlined
              dense
              hide-details
          ></v-autocomplete>
        </template>
      </v-col>
      <v-col cols="12" md="2">
        <v-autocomplete
            v-model="searchParam.operation_id"
            :items="operations"
            :loading="loadingstatus"
            item-text="name"
            item-value="id"
            required
            label="Operation name"
            outlined
            dense
            deletable-chips
            chips
            hide-details
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="2">
        <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="date"
                label="Select Date"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense
                hide-details
            ></v-text-field>
          </template>
          <v-date-picker v-model="date" range></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" md="2">
        <template>
          <v-autocomplete
              :items="statusList"
              color="white"
              label="Status"
              v-model="searchParam.status"
              :loading="loadingstatus"
              outlined
              dense
              hide-details
              deletable-chips
              chips
          ></v-autocomplete>
        </template>
      </v-col>
      <v-col cols="12" md="1">
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            hide-details
            :loading="loadingstatus"
            outlined
            dense
        ></v-text-field>
      </v-col>
      <v-col md="3">
        <template>
          <v-row align="center" justify="space-around">
            <v-btn depressed color="primary" v-on:click="getReports"
            ><v-icon>mdi-magnify</v-icon></v-btn
            >
            <v-btn depressed color="primary" append-icon="mdi-printer" @click="printList"
            ><v-icon>mdi-printer</v-icon>
            </v-btn>

            <v-btn depressed color="primary" append-icon="mdi-printer" @click="createNew"
            ><v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-btn depressed color="warning" append-icon="mdi-printer" @click="cancelList"
            >Cancel List
            </v-btn>
          </v-row>
        </template>
      </v-col>
    </v-card-title>
    <v-card>
      <v-data-table
          :headers="headers"
          :items="desserts"
          class="elevation-1"
          :search="search"
          dense
          disable-pagination
          :hide-default-footer="true"
          :loading="loadingstatus"
          loading-text="Loading... Please wait"
      >
        <template v-slot:item.operation_subhead="{ item }">
          <span v-if="item.operation">{{ item.operation.name }}</span>
          <v-chip v-if="item.operation_subhead" class="ma-2" color="error" outlined small>
            {{ item.operation_subhead }}
          </v-chip>
        </template>
        <template v-slot:item.status="{ item }">
          <div class="d-flex justify-center font-weight-black">
            <v-chip :color="getColor(item.status)" dark small>
              {{ item.status.toUpperCase() }}
            </v-chip>
          </div>
        </template>
        <template v-slot:item.amount="{ item }">
          <div class="d-flex font-weight-black">
            {{ b_number_format(item.amount) }}
          </div>
        </template>

        <template v-slot:item.actions="{ item }">
          <!-- <v-tooltip top v-if="item.status == 'Registration'">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                @click="ot_details(item)"
                dark
                v-bind="attrs"
                v-on="on"
                class="ma-2"
                color="orange"
                label
                outlined
                small
                ><v-icon small> mdi-chevron-double-right </v-icon>
              </v-chip>
            </template>
            <span>OT Registration Details</span>
          </v-tooltip> -->
          <v-tooltip top v-if="item.status == 'active'">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="ot_schedule(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  color="primary"
                  label
                  outlined
                  small
              ><v-icon small> mdi-pencil </v-icon>
              </v-chip>
            </template>
            <span>Edit </span>
          </v-tooltip>
          <!-- <v-tooltip top v-if="item.status == 'active'">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                @click="ot_registration(item)"
                dark
                v-bind="attrs"
                v-on="on"
                class="ma-2"
                open
                color="green"
                label
                outlined
                small
                ><v-icon small> mdi-mortar-pestle-plus </v-icon>
              </v-chip>
            </template>
            <span>Set Registration </span>
          </v-tooltip> -->
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="getReports">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../../js/setup";
export default {
  data() {
    return {
      search: "",
      date: [
        new Date().toISOString().substr(0, 10),
        new Date().toISOString().substr(0, 10),
      ],
      nowDate: new Date().toISOString().substr(0, 10),
      menu2: false,
      doctor_id: 0,
      doctors: [],
      operations: [],
      statusList: [
        "active",
        "Operation Done",
        "Operation Start",
        "OT Cancel",
        "Ready to Operation",
        "Registration",
        "Waiting",
      ],
      loadingstatus: true,
      isLoading: true,
      searchParam: {
        surgeon_id: 0,
        status: null,
        user_id: null,
        operation_id: null,
      },
      headers: [
        {
          text: "Patient ID",
          value: "patient_id",
        },
        { text: "Patient Name", value: "patient.patient_name" },
        { text: "Doctor", value: "doctor.dr_name" },
        {
          text: "Operation Name",
          sortable: true,
          value: "operation_subhead",
        },
        { text: "Date", sortable: true, value: "operation_date" },
        { text: "Time", sortable: true, value: "starting_time" },
        { text: "OT-Room", sortable: true, value: "ot_no" },
        // { text: "OT Amount", value: "amount" },
        // { text: "Due Amount", value: "due_amount" },
        // { text: "Counselor", value: "counselor.first_name" },
        { text: "Status", value: "status" },
        { text: "Created by", value: "user.last_name" },
        { text: "Action", value: "actions", sortable: false },
      ],
      desserts: [],
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "OT Schedule",
          disabled: true,
          href: "patients",
        },
      ],
      returnUrl: atshq.defaults.headers.common.app_URL,
      returnApiBaseURL: atshq.defaults.headers.common.api_base_URL,
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.getReports();
    this.getDoctors();
    this.getOperations();
  },

  methods: {
    getOperations() {
      atshq
          .get("/operations")
          .then((response) => {
            this.operations = response.data.data;
          })
          .catch((e) => {
            this.errors = true;
            this.errorMessage = e;
          });
    },
    getReports() {
      atshq
          .get(
              "ot-module/schedule?date=" +
              this.date +
              "&surgeon_id=" +
              this.searchParam.surgeon_id +
              "&status=" +
              this.searchParam.status +
              "&operation_id=" +
              this.searchParam.operation_id
          )
          .then((response) => {
            this.desserts = response.data.data;
            this.loadingstatus = false;
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },
    getDoctors() {
      atshq
          .get("doctors")
          .then((response) => {
            this.doctors = response.data.data;
            this.loadingstatus = false;
            this.isLoading = false;
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },
    b_number_format(n) {
      // return n != null
      //   ? n.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
      //   : 0;
      return n;
    },
    getColor(status) {
      if (status == "active") return "orange";
      else if (status == "Registration") return "green";
      else if (status == "cancel") return "red";
    },
    createNew() {
      window.location.href = "/ot-module/schedule-create";
    },
    cancelList() {
      window.location.href = "/ot-module/schedule-cancel";
    },
    printList() {
      if (!this.date) {
        this.$noty.error('Sorry! Please Select Date range');
        return
      }
      window.open(this.returnApiBaseURL + "print/ot-schedule-print?date=" + this.date + '');
      // var kk = this.date;
      // var datesplit = kk.toString().split(",");
      //
      // var date1 = datesplit[0];
      // var date2 = datesplit[1];
      // window.open(
      //     this.returnUrl +
      //     "printdoc/otSchedule/" +
      //     date1 +
      //     "/" +
      //     date2 +
      //     "/" +
      //     this.searchParam.surgeon_id
      // );
    },
    dateSelect() {
      this.loadingstatus = true;
      this.getReports();
    },
    ot_details(item) {
      window.location.href = "/ot-registration/" + item.registration_no;
    },
    ot_schedule(item) {
      window.location.href = "/ot-module/schedule-create?schedule_id=" + item.id;
    },
    ot_registration(item) {
      var result = confirm("Are you Sure?");
      if (result) {
        //Logic to delete the item
        // console.log(item);
        atshq
            .post("ot-module/schedule-ot-registration", {
              data: item,
              user_id: localStorage.getItem("userId"),
            })
            .then((response) => {
              this.loadingstatus = false;
              if (response.data.status == false) {
                this.$noty.error("Oops, something went wrong!");
                this.$noty.error(response.data.messages);
              } else {
                this.$noty.success(response.data.messages);
                window.location.href = "/ot-registration/" + response.data.data;
                this.getReports();
              }
            })
            .catch((e) => {
              this.errors.push(e);
            });
      }
    },
  },
};
</script>
